var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"value":_vm.value,"label":_vm.label,"append-icon":"mdi-magnify","background-color":"#d9e1ec","clearable":"","dense":"","filled":"","rounded":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }